import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/services/query-keys';
import {
  searchGoogleKeywords,
  searchGoogleAudiences,
  searchGoogleGeoTargets,
} from './ads-google-api';

const STALE_MS = 5 * 60 * 1000;

export function useGoogleKeywordSearch(adAccountId: string | undefined, query: string) {
  return useQuery({
    queryKey: queryKeys.adsGoogle.keywords(adAccountId ?? 'managed', query),
    queryFn: () => searchGoogleKeywords(adAccountId, query),
    enabled: query.trim().length >= 1,
    staleTime: STALE_MS,
    retry: 0,
  });
}

export function useGoogleGeoTargetSearch(adAccountId: string | undefined, query: string) {
  return useQuery({
    queryKey: queryKeys.adsGoogle.geoTargets(adAccountId ?? 'managed', query),
    queryFn: () => searchGoogleGeoTargets(adAccountId, query),
    enabled: query.trim().length >= 1,
    staleTime: STALE_MS,
    retry: 0,
  });
}

export function useGoogleAudienceSearch(
  adAccountId: string | undefined,
  query: string,
  type?: 'USER_INTEREST' | 'AUDIENCE' | 'ALL',
) {
  return useQuery({
    queryKey: queryKeys.adsGoogle.audiences(adAccountId ?? 'managed', query, type),
    queryFn: () => searchGoogleAudiences(adAccountId, query, type),
    enabled: query.trim().length >= 1,
    staleTime: STALE_MS,
    retry: 0,
  });
}
